<template>
<!--

  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>
  <router-view/>
-->


  <div class="">
    <app-nav-bar class=""></app-nav-bar>
    <!--
    <header class="bg-white shadow">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold text-gray-900">
          Dashboard
        </h1>
      </div>
    </header>
    -->
    <main class="mb-auto flex-1 overflow-y-auto overflow-x-hidden z-20 main">
      <div class="max-w-7xl mx-auto pb-6 sm:px-6 lg:px-8">
        <!-- Replace with your content -->
        <div class="px-4 pb-6 pt-2 sm:px-0">
          <div class="h-full flex-1 h-96AAA " >
            <router-view/>
          </div>
        </div>
        <!-- /End replace -->
      </div>
    </main>
    <app-footer class="stickyAAA fixed text-xs bottom-0 text-small w-full bg-white" msg="Registered in England and Wales, No. 12663487"></app-footer>
  </div>

</template>

<script lang="ts">


import {defineComponent, onMounted, onUnmounted, watch} from "vue";
// import {Options, Vue} from "vue-class-component";

import AppFooter from "@/components/AppFooter.vue";
import AppNavBar from "@/components/AppNavBar.vue";
import {useLocalStorage, usePreferredDark} from "@vueuse/core";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {WatchStopHandle} from "@vue/runtime-core";
import {nth} from "lodash/fp";
import {useAppSettings} from "@/main";
import {PathLevels, RouterPathInfo} from "@/router";
// import {ISearchResultItem, SearchResultItem} from "@/types/AppTypes";

// import {AppUtils} from "@/utils";
// import CoreService from "@/services/CoreService";
// import {updateAxiosBaseUrlFromProfile} from "@/main";
// import WebSocketService from "@/services/WebSocketService";
// import AccountService from "@/services/account-service";
// import {interval} from "rxjs"

/*@Options({
  components: {AppFooter}
})
export default class App extends Vue {
}
*/

export default defineComponent({
  name: 'App',
  components: {
    AppFooter,
    AppNavBar
  },
  setup() {

    const route = useRoute();
    let stopWatchingRoute:WatchStopHandle;
    const {stg} = useAppSettings();

    onMounted( () => {

      //console.log('App.onMounted - init');
      try {
        // updateAxiosBaseUrlFromProfile();
        // CoreService.updateAppProfile();
      } catch (e) {
        console.error('App.onMounted - ', e)
      }

      stopWatchingRoute = watch(route, (value, oldValue) => {
        processPath(value.path)
      });

      /*// RxJS setup:  https://www.learnrxjs.io/learn-rxjs/operators/creation/interval
      AccountService.syncUserAccount()
      //emit value in sequence every 1 second
      const source = interval(1000 * 10);

      //output: 0,1,2,3,4,5....
      const subscribe = source.subscribe(val => {
        //console.log('App.Scheduler.Interval: ', val);
        const wsStatus = WebSocketService.status();
        if (!wsStatus.open) {
          WebSocketService.restart()
              .then(function (res:any) {
                console.debug('WebSocketService.restart(): ' + res);
              })
              .catch(function (e_obj:Error) {
                console.error('WebSocketService.restart(): ' + JSON.stringify(e_obj));
              });
        }
      });
      */

      processPath(route.path);
    })

    onUnmounted(() => {
      stopWatchingRoute();
      return;
    })


    const processPathParts = (path:string) => {
      const path_levels = PathLevels.makeFromPath(path);
      if (!path_levels.level_1) {
        return
      }
      stg.nav.selected_id = path_levels.level_1
      stg.nav.path_levels = path_levels
    }

    const processPath = (path:string)=> {
      console.log('processPath: ', path);
      ensureNavSelectedIsBrand(path)
    }

    const ensureNavSelectedIsBrand = (path_part:string) => {
      processPathParts(path_part)
    }

    // is user prefers dark theme
    const isDark = usePreferredDark()

    // persist state in localStorage
    const store_local = useLocalStorage(
        'my-storage',
        {
          name: 'Apple',
          color: 'red',
        },
    )

    return {
      isDark,
      store_local
    }
  },
})

</script>

<style>

.mainAAA {
  position: static;
  z-index: 1;
  overflow-x: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
